"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _commission = require("@/api/marketing/commission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommissionLevelConfig',
  data: function data() {
    return {
      loading: false,
      typeOptions: [{
        label: '佣金',
        value: 1
      }],
      formData: {
        newUserCashAmount: 0,
        newUserPoints: 0,
        walletRangeConfigs: []
      },
      rules: {
        newUserCashAmount: [{
          required: true,
          trigger: ['blur', 'change'],
          message: '请输入新用户赠送金额'
        }]
      }
    };
  },
  created: function created() {
    this.getConfigInfo();
  },
  methods: {
    // 获取配置信息
    getConfigInfo: function getConfigInfo() {
      var _this = this;
      this.loading = true;
      (0, _commission.commissionLevelConfigApi)().then(function (res) {
        var _res$newUserConfig = res.newUserConfig,
          _res$newUserConfig$ne = _res$newUserConfig.newUserCashAmount,
          newUserCashAmount = _res$newUserConfig$ne === void 0 ? 0 : _res$newUserConfig$ne,
          _res$newUserConfig$ne2 = _res$newUserConfig.newUserPoints,
          newUserPoints = _res$newUserConfig$ne2 === void 0 ? 0 : _res$newUserConfig$ne2;
        _this.formData.newUserCashAmount = newUserCashAmount;
        _this.formData.newUserPoints = newUserPoints;
        _this.formData.walletRangeConfigs = res.walletRangeConfigs.map(function (item) {
          var walletMinAmount = item.walletMinAmount,
            walletMaxAmount = item.walletMaxAmount;
          walletMinAmount = parseFloat(walletMinAmount);
          walletMaxAmount = parseFloat(walletMaxAmount);
          var title = "\u4F63\u91D1\u4F59\u989D".concat(walletMinAmount, "\u5143~").concat(walletMaxAmount, "\u5143\u8BBE\u5B9A");
          if (!walletMinAmount) {
            title = "\u4F63\u91D1\u4F59\u989D".concat(walletMaxAmount, "\u5143\u4EE5\u4E0B\u8BBE\u5B9A");
          } else if (!walletMaxAmount) {
            title = "\u4F63\u91D1\u4F59\u989D".concat(walletMinAmount, "\u5143\u4EE5\u4E0A\u8BBE\u5B9A");
          }
          item.title = title;
          return item;
        });
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSubmit: function handleSubmit(name) {
      var _this2 = this;
      this.$refs[name].validate(function (valid, obj) {
        if (valid) {
          _this2.postData();
        } else {
          for (var key in obj) {
            var msg = obj[key][0].message;
            return _this2.$message.warning(msg);
          }
        }
      });
    },
    getFormData: function getFormData() {
      var _this$formData = this.formData,
        _this$formData$newUse = _this$formData.newUserCashAmount,
        newUserCashAmount = _this$formData$newUse === void 0 ? 0 : _this$formData$newUse,
        _this$formData$newUse2 = _this$formData.newUserPoints,
        newUserPoints = _this$formData$newUse2 === void 0 ? 0 : _this$formData$newUse2,
        _this$formData$wallet = _this$formData.walletRangeConfigs,
        walletRangeConfigs = _this$formData$wallet === void 0 ? [] : _this$formData$wallet;
      return {
        newUserConfig: {
          newUserCashAmount: newUserCashAmount,
          newUserPoints: newUserPoints
        },
        walletRangeConfigs: walletRangeConfigs
      };
    },
    // 新增保存数据
    postData: function postData() {
      var _this3 = this;
      this.loading = true;
      var data = this.getFormData();
      (0, _commission.commissionUpdateLevelConfigApi)(data).then(function (data) {
        _this3.$message.success('保存成功');
      }).finally(function (err) {
        _this3.loading = false;
      });
    }
  }
};